import { Button, Modal, Typography } from '@mui/material';
import { Box } from '@mui/system';
import CircularComponent from './CircularComponent';

const style = {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '27vw',
    bgcolor: '#FFF',
    border: '1px solid #000',
    boxShadow: 24,
    p: 4
};

export const ConfirmationModal = ({ open, action, close, loader, nextFuntion, errorMessage, component }) => {
    return (
        <Modal open={open} onClose={close} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <Box sx={style}>
                <Typography id="modal-modal-title" component="label">
                    You are going to {action} this {component}, are you sure?
                </Typography>
                <Box marginTop="1em" alignSelf="end">
                    {loader ? (
                        <button style={{ backgroundColor: '#FFF', border: 'none' }}>
                            <CircularComponent />
                        </button>
                    ) : (
                        <Button variant="contained" sx={{ borderRadius: '4px' }} onClick={() => nextFuntion()}>
                            Yes
                        </Button>
                    )}
                </Box>
                {errorMessage && <label style={{ color: '#F65570', fontSize: 11, marginTop: 15 }}> {errorMessage}</label>}
            </Box>
        </Modal>
    );
};

export default ConfirmationModal;
